import api from '.';

export interface GetForgotPasswordParams {
  email: string;
}

export interface UpdateResetPassword {
  password: string;
  token: string;
}

export async function getForgotPassword(params: GetForgotPasswordParams) {
  const { data } = await api.get(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/reset-password-external-users/forgot`,
    {
      params
    }
  );
  return data;
}

export async function updateResetPassword(
  updateResetPassword: UpdateResetPassword
) {
  const { data } = await api.put(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/reset-password-external-users/reset`,
    updateResetPassword
  );
  return data;
}
